import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

@Entity()
export class BasePartnerEditSchoolformExtension extends BaseEditExtension {
  static override _class = 'BasePartnerEditSchoolformExtension';
}
